import React from 'react'
import "./Footer.css"

const Footer = () => {
    return (
        <>
            <div className='footerContainer'>

                <div className='footer'>
                    <h4 className='footerHead'>CUSTOMER SERVICE</h4>
                    <div className='footerText'>Shipping & Delivery Policy</div>
                    <div className='footerText'>Return, Exchange and Refunds policy for Bags</div>
                    <div className='footerText'>Return, Exchange and Refunds policy for hells</div>
                    <div className='footerText'>Privacy Policy</div>
                    <div className='footerText'>Color Variation and Wear Tear</div>
                    <div className='footerText'>Terms of Service</div>
                    <div className='footerText'>Intellectual Property & Trademarks</div>
                    <div className='footerText'>Contact Us</div>
                </div>

            </div>
            <div className='copyrights'>
                <div className='footerText'>@RASHKI</div>
                <div className='footerText'>Design by Marstechs</div>
            </div>





        </>
    )
}

export default Footer